export default "__VITE_ASSET__CKZ92ZCl__"